<template>
  <div class="order-wrapper">
    <portal target-el="#filter">
      <PrimaryFilter
        :menuOptions="menuOptions"
        :selectedCategory="seletedCategory"
        :enableSearchPopup="enableSearchPopup"
        :searchParameters="searchParameters"
        :preSearchedParams="searchedParams"
        :buttonsList="buttonsList"
        :isUploading="isUploading"
        @searchByParameter="searchByParams"
        @bulkUpload="bulkUpload"
        @rejectDownload="rejectDownload"
        @exportData="exportData"
        @getExcel="getExcel"
        @add="openAddSlider"
        :searchText="$t('MDM_SEARCH')"
      />
    </portal>
    <div class="top slideleft_drawer" :class="{ openSlideleft: openSlideleft }">
      <div
        class="slideleft_content"
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="loadCheck"
        infinite-scroll-throttle-delay="400"
        infinite-scroll-distance="10">
        <MdmHeader
          :headers="sectionHeaders"
          :hasColumnPicker="true"
          :noCheckbox="true"
          :maxDisplayColumn="maxDisplayColumn" />
        <div v-if="isLoading" class="paymentloader"></div>
        <div v-else-if="list.length === 0" class="emptydiv">
          <div class="paymentempty"></div>
          <div class="emptytext">{{$t('MDM_NO_DATA_FOUND')}}</div>
        </div>
        <MdmRow
          v-for="(freightZone, index) in freightZoneList"
          :key="index"
          :data="freightZone"
          :headers="sectionHeaders"
          :isRowClickable="showEdit"
          @routeToDetails="openEditForm(freightZone)"
        />
      </div>
    </div>
    <div class="slideleft_drawer">
      <div class="slideleft_content">
        <div class="content pt-20" v-if="showForm">
          <Drawer
            :visible.sync="showForm"
            direction="rtl"
            size="500px"
            :modal="true"
            :withHeader="false"
            :wrapperClosable="false"
            :append-to-body="true"
            class="default-drawer" >
            <Link :underline="false" class="nav-close" @click="closeSlider">
              <svgicon
                name="cancelwhite"
                width="12"
                height="12"
                :original="true" />
            </Link>
            <Form
              v-if="!isLoadingFormConstants"
              :formConstant="addFormConstants"
              :data="selectedRow"
              :isEdit="isEditForm"
              sectionTitle="Freight zone"
              @cancel="closeSlider"
              @add="add"
              @update="update" />
          </Drawer>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import MdmHeader from '@common/components/HeaderV2';
import MdmRow from '@common/components/mdm-v2/Row';
import FilterWrapper from '@common/components/FilterWrapperV2';
import Form from '@common/components/mdm-v2/Form';

import PrimaryFilter from '@/components/common/PrimaryFilter';
import SharedMdm from '@/components/mixins/SharedMdmV2';

export default {
  name: 'FreightZones',
  components: {
    PrimaryFilter,
    MdmHeader,
    MdmRow,
    FilterWrapper,
    Form,
  },
  mixins: [SharedMdm],
  data() {
    return {
      skipEditPermission: false,
      openSlideleft: false,
      maxDisplayColumn: 2,
      isLoadingFormConstants: false,
    };
  },
  created() {
    this.loadSearchFromSession();
    this.loadMore();
  },
  computed: {
    ...mapState('mdmV2', ['isLoading', 'all', 'isUploading']),
    freightZoneList() {
      return this.list && this.list.map(freightZone => ({
        id: freightZone.id,
        name: this.capitalizeFirstLetter(freightZone.name),
        pincodes: freightZone.pincodes,
      }));
    },

  },
  methods: {
    openEditForm(data) {
      this.selectedRow = {
        id: data.id,
        name: data.name,
        pincodes: data.pincodes.map((d, index) => ({
          pincode: d,
          sno: index + 1,
        })),
      };
      this.isEditForm = true;
      this.openSlider();
    },
    capitalizeFirstLetter(string) {
      return string.trim().charAt(0).toUpperCase() + string.trim().slice(1);
    },
    loadSearchFromSession() {
      const sessionSearchParamsJSON =
        localStorage.getItem(`${this.$route.name}-search-popup`) || '{}';
      const sessionSearchParams = JSON.parse(sessionSearchParamsJSON);
      this.searchedParams = { ...this.searchedParams, ...sessionSearchParams };
    },
    saveSearchToSession() {
      const sessionSearch = JSON.stringify(this.searchedParams);
      localStorage.setItem(`${this.$route.name}-search-popup`, sessionSearch);
    },
    searchByParams(params) {
      this.searchByParameter(params);
      this.saveSearchToSession();
    },
  },
};
</script>

